// === wizardStepSeries.js START ====================================================================

wizardSteps["series"] = {
    templateName: "#m-modal__series-selector-template",
    beforeRender: function (ctx) {
        if (ctx.model.o && ctx.model.o.title) {
            ctx.model.modalTitle = ctx.model.o.title;
        } else {
            ctx.model.modalTitle = $t("Neuer Termin");
        }

        // Meta information about the appointment
        ctx.model.m = {
            // For mes, template selection is only visible for new single training appointments
            showTemplateSelection: currentEvent.appointmentType === "SingleTraining"
                && (calendarConfiguration.loginUserType !== "Me" || !ctx.model.o.id)
        };

        if (!currentEvent.series) {
            var utcNow = moment().utcOffset(0, true);
            currentEvent.series = {
                repeatType: "Day",
                repeatInterval: 1,
                endType: "OnDate",
                endAmount: "",
                endDate: (currentEvent.start.toDate().setHours(0, 0, 0, 0) > utcNow.toDate().setHours(0, 0, 0, 0) ? currentEvent.start : moment(utcNow).add(1, 'day')).format('YYYY-MM-DD')+'T00:00:00'
            };
        }

        ctx.model.series = currentEvent.series;
    },
    afterRender: function (ctx) {
        // Events are bound here
        var $isSeries = $("#m-modal__input--series-isSeries");
        var $repeatInterval = $("#m-modal__input--series-interval");
        var $endDate = $("#m-modal__input--series-endDate");
        var $endAmount = $("#m-modal__input--series-endAmount");
        var $endAmountText = $("#m-modal__input--series-endAmount-text");
        var $endType = $("#m-modal__select--series-endType");
        var $repeatType = $("#m-modal__select--series-repeatType");

        $isSeries.prop('checked', ctx.model.o.isSeries);

        var activeFields = function (enable) {
            $repeatInterval.prop('disabled', enable);
            $repeatType.prop('disabled', enable);
            $endType.prop('disabled', enable);
            $endDate.prop('disabled', enable);
        };

        if (!$isSeries.is(':checked')) {
            activeFields('disabled');
        }

        $endType.children().remove();
        $endType.append('<option value="OnDate" data-index="0">' + $t("Am") + '</option>');
        $endType.append('<option value="AfterOccurrences" data-index="1">' + $t("Nach") + '</option>');

        $endType.children('[value="' + ctx.model.series.endType + '"]').prop('selected', true);

        var ShowEndTypeFields = function (typeValue) {
            if (typeValue === "AfterOccurrences") {
                $endDate.hide();
                $endAmount.show();
                $endAmountText.show();
            } else {
                $endDate.show();
                $endAmount.hide();
                $endAmountText.hide();
            }
        };

        ShowEndTypeFields(ctx.model.series.endType);

        $repeatType.children().remove();
        $repeatType.append('<option value="Day" data-index="0">' + $t("Tage") + '</option>');
        $repeatType.append('<option value="Month" data-index="1">' + $t("Monate") + '</option>');

        $repeatType.children('[value="' + ctx.model.series.repeatType + '"]').prop('selected', true);

        $endDate.datepicker({
            dateFormat: dateTimeFormatString.dateFormatPicker
        }).val(moment(currentEvent.series.endDate).format('L'));

        $endType.on("change", function () {
            ShowEndTypeFields(this.value);
        });

        $isSeries.on("click", function () {            
            if ($isSeries.is(':checked')) {
                activeFields('');
            } else {
                activeFields('disabled');
            }            
        });
    },
    save: function () {
        var $isSeries = $("input[name='isSeries']");
        var $repeatInterval = $("#m-modal__input--series-interval");
        var $repeatType = $("#m-modal__select--series-repeatType");
        var $endDate = $("#m-modal__input--series-endDate");
        var $endAmount = $("#m-modal__input--series-endAmount");
        var $endType = $("#m-modal__select--series-endType");

        // Validate inputs a little because the server returns a 400 if presented with non-number values here
        var repeatInterval = parseInt($repeatInterval.val());
        if (isNaN(repeatInterval)) {
            repeatInterval = 0;
        }
        var endAmount = parseInt($endAmount.val());
        if (isNaN(endAmount)) {
            endAmount = null;
        }

        currentEvent.series = {
            repeatType: $repeatType.val(),
            repeatInterval: repeatInterval,
            endType: $endType.val(),
            endDate: moment($endDate.datepicker('getDate')).format('YYYY-MM-DD') + "T00:00:00",
            endAmount: endAmount
        };

        currentEvent.isSeries = $isSeries.is(':checked');
    },
    getButtonList: function () {
        return {
            "updateseries": true
        };
    }
};

// === wizardStepSeries.js START ====================================================================
